/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm, FormProvider } from "react-hook-form";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { FiSave } from "react-icons/fi";
import { TiFlash } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from "recharts";
import { useAuthContext } from "../../context/auth";
import {
  getIntermediarios,
  updateCliente,
  getOportunidades,
  getCategorias,
  getUsers,
  getClientes,
  updateOportunidad,
  getOportunidadesBTL,
  useCurrency,
} from "../../utils";
import { AgenciasDropdown, matchAgenciaFilter } from "../AgenciasDropdown";
import styles from "./VentasMiListaClientes.module.scss";

export const VentasMiListaClientes = ({ renderHeader, filterStyles }) => {
  const s = filterStyles || styles;
  const [clientes, setClientesPublicitarios] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setEditingClienteId] = useState(null);
  const [editingClienteContact, setEditingClienteContact] = useState(null);
  const [editingAgenciaContact, setEditingAgenciaContact] = useState(null);
  const [ultimo_contacto_fecha_cliente, setUltimoContactoFechaCliente] = useState(null);
  const [ultimo_contacto_accion_cliente, setUltimoContactoAccionCliente] = useState("");
  const [proximo_contacto_fecha_cliente, setProximoContactoFechaCliente] = useState(null);
  const [proximo_contacto_accion_cliente, setProximoContactoAccionCliente] = useState("");
  const [ultimo_contacto_fecha_agencia, setUltimoContactoFechaAgencia] = useState(null);
  const [ultimo_contacto_accion_agencia, setUltimoContactoAccionAgencia] = useState("");
  const [proximo_contacto_fecha_agencia, setProximoContactoFechaAgencia] = useState(null);
  const [proximo_contacto_accion_agencia, setProximoContactoAccionAgencia] = useState("");
  const [todasLasOportunidades, setTodasLasOportunidades] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroMes, setFiltroMes] = useState([]);
  const [filtroEstatus, setFiltroEstatus] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [sumasFiltradas, setSumasFiltradas] = useState({
    "100%": 0,
    "90%": 0,
    "75%": 0,
    "50%": 0,
    "0%": 0,
  });
  const [sumCierres, setSumCierres] = useState(0);
  const [usuarios, setUsuarios] = useState([]);
  const [ordenamiento, setOrdenamiento] = useState({
    porFecha: "null",
  });
  const [data, setData] = useState([
    {
      name: "Total",
      "100%": 0,
      "90%": 0,
      "75%": 0,
      "50%": 0,
      "0%": 0,
      empty: 100,
    },
  ]);
  const [tipoCliente, setTipoCliente] = useState("");
  const [filtroCategoriaCliente, setFiltroCategoriaCliente] = useState([]);
  const [filtroProducto, setFiltroProducto] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState(null);
  const [selectedOportunidadId, setSelectedOportunidadId] = useState(null);
  const [flashEditingOpportunity, setFlashEditingOpportunity] = useState(null);
  const [isFlashEditing, setIsFlashEditing] = useState(false);
  const [filtroUsuario, setFiltroUsuario] = useState("");
  const [todasLasOportunidadesBTL, setTodasLasOportunidadesBTL] = useState([]);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [ventasData, setVentasData] = useState({
    ventasPorCliente: {},
    ventasYTD: {},
    ventasHTD: {},
    oportunidades90: {},
    oportunidades75: {},
    oportunidades50: {},
  });
  const getCurrentYear = () => new Date().getFullYear().toString();
  const CURRENT_YEAR = getCurrentYear(); // "2026"
  const { pais, rol, id } = useAuthContext() || {};

  const { usdToLocal, loadingRates } = useCurrency();

  const getTasaCambio = useCallback(() => {
    if (!usdToLocal || loadingRates) return 1;
    return usdToLocal;
  }, [usdToLocal, loadingRates]);

  const navigate = useNavigate();

  const methods = useForm();

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = methods;

  const clientesMemo = useMemo(() => clientes, [clientes]);

  const todasLasOportunidadesMemo = useMemo(() => todasLasOportunidades, [todasLasOportunidades]);

  const todasLasOportunidadesBTLMemo = useMemo(() => todasLasOportunidadesBTL, [todasLasOportunidadesBTL]);

  const clienteCategoriaMap = useMemo(() => {
    const map = {};
    clientes.forEach((cliente) => {
      const categoria = categorias.find((cat) => cat.id.toString() === cliente.categoria.toString());
      map[cliente.id] = categoria ? categoria.nombre : "";
    });
    return map;
  }, [clientes, categorias]);

  // Integración de funciones de utils/calculateVentas.js
  const getConvertedImporte = (oportunidad, rate) =>
    oportunidad.moneda_dolar ? (oportunidad.importe || 0) * rate : oportunidad.importe || 0;

  const getConvertedImporteBTL = (oportunidadBTL, rate) =>
    oportunidadBTL.moneda_dolar ? (oportunidadBTL.total_investment || 0) * rate : oportunidadBTL.total_investment || 0;

  const normalizeMonth = (month, createdAt, ano = null) => {
    if (!month || typeof month !== "string") {
      if (ano) return `01-${ano}`;
      return null;
    }
    if (/^\d{2}-\d{4}$/.test(month)) return month;
    const monthNum = parseInt(month, 10);
    if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && ano) {
      return `${monthNum.toString().padStart(2, "0")}-${ano}`;
    }
    return null;
  };

  const calculateSalesSums = (oportunidades, oportunidadesBTL, year, startMonth = 1, endMonth = 12, rate, pais) => {
    const filterAndSum = (ops, status, field, includeMin = false, isBTL = false) => {
      const filteredOps = ops.filter((op) => {
        const useField = op[field] ? field : op.estatus === "100%" && !isBTL ? "mes_cierre" : null;
        if (!useField || !op[useField]) {
          return false;
        }
        const [month, ano] = op[useField].split("-").map(Number);
        const estatus = isBTL ? (op.status === 100 ? "100%" : `${op.status || 0}%`) : op.estatus;
        return estatus === status &&
          !op.eliminada &&
          ano === parseInt(year) &&
          month >= startMonth &&
          month <= endMonth &&
          op.pais === pais
          ? true
          : false;
      });
      const groups = {};
      filteredOps.forEach((op) => {
        const key = op.client_id;
        if (!groups[key]) groups[key] = [];
        const importe = isBTL ? getConvertedImporteBTL(op, rate) : getConvertedImporte(op, rate);
        groups[key].push(importe);
      });
      let total = 0;
      for (const key in groups) {
        const importes = groups[key];
        total +=
          includeMin && importes.length > 1 ? Math.min(...importes) : importes.reduce((sum, val) => sum + val, 0);
      }
      return total;
    };
    const sumCierresRegular = filterAndSum(oportunidades, "100%", "mes_cierre", false, false);
    const sumCierresBTL = filterAndSum(oportunidadesBTL, "100%", "mes_cierre", false, true);
    const sumaImportes100Regular = filterAndSum(oportunidades, "100%", "mes_factura", false, false);
    const sumaImportes100BTL = filterAndSum(oportunidadesBTL, "100%", "mes_factura", false, true);
    const sumaImportes90 = filterAndSum(oportunidades, "90%", "mes_cierre", true, false);
    const sumaImportes75 = filterAndSum(oportunidades, "75%", "mes_cierre", true, false);
    const sumaImportes50 = filterAndSum(oportunidades, "50%", "mes_cierre", true, false);
    const sumaImportes0 = filterAndSum(oportunidades, "0%", "mes_cierre", true, false);
    return {
      sumCierres: sumCierresRegular + sumCierresBTL,
      sumaImportes100: sumaImportes100Regular + sumaImportes100BTL,
      sumaImportes90,
      sumaImportes75,
      sumaImportes50,
      sumaImportes0,
    };
  };

  const calculateVentasYOportunidades = (oportunidades, oportunidadesBTL, clientes, currentYear = CURRENT_YEAR) => {
    const ventasPorCliente = {};
    const ventasYTD = {}; // Ventas que se facturarán en el año actual
    const ventasHTD = {}; // Ventas facturadas en años anteriores

    // Helper para obtener el año de facturación
    const getFacturaYear = (op) => {
      // Prioridad 1: facturafecha
      if (op.facturafecha) {
        const facturaDate = new Date(op.facturafecha);
        if (!isNaN(facturaDate.getTime())) {
          return String(facturaDate.getFullYear());
        }
      }
      // Prioridad 2: mes_factura (formato "MM-YYYY")
      if (op.mes_factura) {
        const parts = op.mes_factura.split("-");
        if (parts.length === 2) {
          return parts[1];
        }
      }
      return null;
    };

    // Procesar oportunidades publicitarias
    oportunidades.forEach((op) => {
      const estatus = op.estatus ? op.estatus.trim() : "0%";
      if (!op.eliminada && op.pais === pais && estatus === "100%") {
        const clientId = op.client_id;
        const importe = getConvertedImporte(op, getTasaCambio());

        // Determinar el año de FACTURACIÓN (no de cierre)
        const facturaYear = getFacturaYear(op);

        // Total general (mantener compatibilidad)
        if (!ventasPorCliente[clientId]) ventasPorCliente[clientId] = 0;
        ventasPorCliente[clientId] += importe;

        // YTD: Facturación del año actual
        if (facturaYear === currentYear) {
          if (!ventasYTD[clientId]) ventasYTD[clientId] = 0;
          ventasYTD[clientId] += importe;
        }

        // HTD: Facturación de años anteriores (excluye año actual)
        if (facturaYear && facturaYear !== currentYear) {
          if (!ventasHTD[clientId]) ventasHTD[clientId] = 0;
          ventasHTD[clientId] += importe;
        }
      }
    });

    // Procesar oportunidades BTL
    oportunidadesBTL.forEach((opBTL) => {
      const estatus = opBTL.estatus ? opBTL.estatus.trim() : opBTL.status ? `${opBTL.status}%` : "0%";
      if (!opBTL.eliminada && opBTL.pais === pais && (estatus === "100%" || opBTL.status === 100)) {
        const clientId = opBTL.client_id;
        const importe = getConvertedImporteBTL(opBTL, getTasaCambio());

        // Determinar el año de FACTURACIÓN (no de cierre)
        const facturaYear = getFacturaYear(opBTL);

        // Total general
        if (!ventasPorCliente[clientId]) ventasPorCliente[clientId] = 0;
        ventasPorCliente[clientId] += importe;

        // YTD: Facturación del año actual
        if (facturaYear === currentYear) {
          if (!ventasYTD[clientId]) ventasYTD[clientId] = 0;
          ventasYTD[clientId] += importe;
        }

        // HTD: Facturación de años anteriores
        if (facturaYear && facturaYear !== currentYear) {
          if (!ventasHTD[clientId]) ventasHTD[clientId] = 0;
          ventasHTD[clientId] += importe;
        }
      }
    });

    return [ventasPorCliente, ventasYTD, ventasHTD];
  };

  const getIntermediarioNombre = useCallback(
    (intermediarioValue) => {
      if (typeof intermediarioValue === "string" && !/^\d+$/.test(intermediarioValue)) return intermediarioValue;
      const intermediario = intermediarios.find(
        (inter) => String(inter.id) === String(intermediarioValue) && inter.pais === pais
      );
      return intermediario ? intermediario.nombre : "";
    },
    [intermediarios, pais]
  );

  const sortContacts = (contactIds, usuarios, type, priorityRoles) => {
    const validContacts = contactIds
      .filter((id) => id && usuarios.find((user) => String(user.id) === String(id)))
      .map((id) => usuarios.find((user) => String(user.id) === String(id)))
      .sort((a, b) => {
        const roleA = a.rol ? a.rol.toLowerCase().trim() : "";
        const roleB = b.rol ? b.rol.toLowerCase().trim() : "";
        const priorityA = priorityRoles.indexOf(roleA);
        const priorityB = priorityRoles.indexOf(roleB);
        if (priorityA !== priorityB) return priorityA - priorityB;
        return `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`);
      });
    return validContacts;
  };

  const filtrarOportunidades = useCallback(
    () =>
      todasLasOportunidadesMemo.filter((oportunidad) => {
        const clienteMatch = clientesMemo.find((c) => c.id === oportunidad.client_id);
        const intermediarioId = clienteMatch ? clienteMatch.agencia : null;
        const matchesIntermediario = matchAgenciaFilter(filtroIntermediario, intermediarioId, pais);
        const clienteCategoria = clienteMatch ? clienteMatch.categoria : null;
        const clienteNombre = clienteMatch ? clienteMatch.empresa.toLowerCase() : "";
        const clienteProducto = clienteMatch ? clienteMatch.producto : "";
        const matchesEjecutivo =
          !filtroEjecutivo ||
          clienteMatch?.ejecutivos_asignados?.includes(Number(filtroEjecutivo)) ||
          String(clienteMatch?.ejecutivo) === String(filtroEjecutivo);

        // Para filtro de mes: prioridad 1 = facturafecha, prioridad 2 = mes_factura
        let mesFacturaStr = null;
        if (oportunidad.facturafecha) {
          const facturaDate = new Date(oportunidad.facturafecha);
          if (!isNaN(facturaDate.getTime())) {
            mesFacturaStr = String(facturaDate.getMonth() + 1).padStart(2, "0");
          }
        }
        if (!mesFacturaStr && oportunidad.mes_factura) {
          mesFacturaStr = oportunidad.mes_factura.split("-")[0] || null;
        }

        return (
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesFacturaStr && filtroMes.includes(mesFacturaStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(oportunidad.estatus || "0%")) &&
          matchesIntermediario &&
          (filtroCategoria === "" || (clienteCategoria && parseInt(clienteCategoria) === parseInt(filtroCategoria))) &&
          matchesEjecutivo
        );
      }),
    [
      todasLasOportunidadesMemo,
      clientesMemo,
      filtroCliente,
      filtroProducto,
      filtroMes,
      filtroEstatus,
      filtroIntermediario,
      filtroCategoria,
      filtroEjecutivo,
      pais,
    ]
  );

  const filtrarOportunidadesMemo = useMemo(() => filtrarOportunidades(), [filtrarOportunidades]);
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const getPaisCode = (countryName) => {
    switch (countryName.toLowerCase()) {
      case "Uruguay":
        return "URU";
      case "Chile":
        return "CHI";
      case "Perú":
        return "PER";
      default:
        return countryName;
    }
  };
  const toUpperCase = (text) => text?.toString().toUpperCase();

  const convertirAMonedaLocal = useCallback(
    (importe, monedaDolar) => {
      if (!monedaDolar) return Number(importe);
      return Number(importe) * getTasaCambio();
    },
    [getTasaCambio]
  );

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes) - 1] || "";
  }, []);

  const months = [
    { value: "01", label: "ENE" },
    { value: "02", label: "FEB" },
    { value: "03", label: "MAR" },
    { value: "04", label: "ABR" },
    { value: "05", label: "MAY" },
    { value: "06", label: "JUN" },
    { value: "07", label: "JUL" },
    { value: "08", label: "AGO" },
    { value: "09", label: "SEP" },
    { value: "10", label: "OCT" },
    { value: "11", label: "NOV" },
    { value: "12", label: "DIC" },
  ];

  const getMonedaSymbol = useCallback(() => {
    const symbols = {
      Chile: "$",
      Perú: "S/",
      Uruguay: "$",
    };
    return symbols[pais] || "$";
  }, [pais]);

  const formatMoneda = useCallback(
    (valor, monedaDolar = false) => {
      if (valor === null || valor === undefined || isNaN(valor)) return "-";

      const valorFinal = monedaDolar ? valor : valor;
      const simbolo = monedaDolar ? "US$" : getMonedaSymbol();

      // Formato según país
      const decimals = pais === "Perú" ? 2 : 0;
      const formatted = Number(valorFinal).toLocaleString(
        pais === "Chile" ? "es-CL" : pais === "Perú" ? "es-PE" : "es-UY",
        {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }
      );

      return `${simbolo} ${formatted}`;
    },
    [pais, getMonedaSymbol]
  );
  const renderProductosOptions = () => {
    const productosFiltrados = filtroCliente
      ? clientes.filter((c) => c.empresa === filtroCliente).map((c) => c.producto)
      : [];
    const productosOrdenados = [...new Set(productosFiltrados)].sort();
    return productosOrdenados.map((producto, index) => (
      <option key={index} value={producto || ""}>
        {producto || "Sin producto"}
      </option>
    ));
  };
  const renderUsuariosOptions = () => {
    const usuariosUnicos = [
      ...new Set(
        clientes
          .flatMap((cliente) => [
            cliente.contacto_cliente,
            cliente.contacto_cliente_1,
            cliente.contacto_cliente_2,
            cliente.contacto_cliente_3,
            cliente.contacto_agencia,
            cliente.contacto_agencia_1,
            cliente.contacto_agencia_2,
            cliente.contacto_agencia_3,
          ])
          .filter((id) => id && usuarios.find((user) => String(user.id) === String(id)))
          .map((id) => usuarios.find((user) => String(user.id) === String(id)))
          .map((user) => user.id)
      ),
    ]
      .map((id) => {
        const user = usuarios.find((user) => String(user.id) === String(id));
        const clienteAsociado = clientes.find(
          (cliente) =>
            cliente.contacto_cliente === id ||
            cliente.contacto_cliente_1 === id ||
            cliente.contacto_cliente_2 === id ||
            cliente.contacto_cliente_3 === id
        );
        const agenciaAsociada = clientes.find(
          (cliente) =>
            cliente.contacto_agencia === id ||
            cliente.contacto_agencia_1 === id ||
            cliente.contacto_agencia_2 === id ||
            cliente.contacto_agencia_3 === id
        );
        let nombreAsociado = "";
        if (clienteAsociado) {
          nombreAsociado = clienteAsociado.empresa;
        } else if (agenciaAsociada) {
          nombreAsociado = getIntermediarioNombre(agenciaAsociada.agencia);
        }
        return {
          id,
          nombre: `${user.nombre} ${user.apellido}${nombreAsociado ? `, ${nombreAsociado}` : ""}`,
        };
      })
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
    return usuariosUnicos.map((usuario, index) => (
      <option key={index} value={usuario.id}>
        {usuario.nombre}
      </option>
    ));
  };
  const getProductosCount = (empresa) => {
    const filteredClientes = clientes.filter((c) => c.empresa === empresa);
    return [...new Set(filteredClientes.map((c) => c.producto))].length;
  };
  const isEditableByDate = (createdAt) => {
    const cutoffDate = new Date("2025-04-19");
    const createdDate = new Date(createdAt);
    if (isNaN(createdDate)) return false;
    return createdDate >= cutoffDate;
  };
  const getDaysDifference = (dateString, isFuture = false) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("-").map(Number);
    const targetDate = new Date(year, month - 1, day);
    if (isNaN(targetDate.getTime())) return "-";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffTime = targetDate - today;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    if (isFuture) {
      if (diffDays < 0) return "Contactar!";
      if (diffDays === 0) return "Hoy";
      if (diffDays === 1) return "Mañana";
      const todayDayOfWeek = today.getDay();
      const daysUntilSunday = todayDayOfWeek === 0 ? 0 : 7 - todayDayOfWeek;
      const endOfCurrentWeek = new Date(today);
      endOfCurrentWeek.setDate(today.getDate() + daysUntilSunday);
      const startOfNextWeek = new Date(endOfCurrentWeek);
      startOfNextWeek.setDate(endOfCurrentWeek.getDate() + 1);
      const endOfNextWeek = new Date(startOfNextWeek);
      endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
      if (targetDate >= today && targetDate <= endOfCurrentWeek) return "Esta semana";
      if (targetDate >= startOfNextWeek && targetDate <= endOfNextWeek) return "Próxima semana";
      return "15 días o más";
    } else {
      if (diffDays === 0) return "Hoy";
      if (diffDays === -1) return "Ayer";
      const todayDayOfWeek = today.getDay();
      const startOfCurrentWeek = new Date(today);
      startOfCurrentWeek.setDate(today.getDate() - (todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1));
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      if (targetDate >= startOfCurrentWeek && targetDate <= yesterday) return "Esta semana";
      const startOfLastWeek = new Date(startOfCurrentWeek);
      startOfLastWeek.setDate(startOfCurrentWeek.getDate() - 7);
      const endOfLastWeek = new Date(startOfLastWeek);
      endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
      const startOfTwoWeeksAgo = new Date(startOfLastWeek);
      startOfTwoWeeksAgo.setDate(startOfLastWeek.getDate() - 7);
      const endOfTwoWeeksAgo = new Date(startOfTwoWeeksAgo);
      endOfTwoWeeksAgo.setDate(startOfTwoWeeksAgo.getDate() + 6);
      if (targetDate >= startOfTwoWeeksAgo && targetDate <= endOfTwoWeeksAgo) return "Hace 2 semanas";
      if (targetDate >= startOfLastWeek && targetDate <= endOfLastWeek) return "Semana pasada";
      if (diffDays < -14) return "15 días o más";
      return "-";
    }
  };
  const getStatusFromText = (text, isFuture = false) => {
    if (!text || text === "-") return "default";
    const normalizedText = text.toLowerCase();
    if (isFuture) {
      if (normalizedText.startsWith("contactar!")) return "expired";
      if (normalizedText === "hoy" || normalizedText === "mañana") return "todayTomorrow";
      if (normalizedText === "esta semana") return "thisWeek";
      if (normalizedText === "próxima semana") return "nextWeek";
      if (normalizedText === "15 días o más") return "later";
    }
    return "default";
  };
  const handleMesChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMes(selectedMonths);
  }, []);
  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`mes${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtroMes.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={handleMesChange}
          style={{ marginLeft: "-35px" }}
        />
        <label className="form-check-label" htmlFor={`mes${index}`} style={{ marginLeft: "0px" }}>
          {mes}
        </label>
      </div>
    ));
  const renderClientesOptions = () => {
    const clientesOrdenados = [...new Set(clientes.map((cliente) => cliente.empresa))].sort();
    return clientesOrdenados.map((empresa, index) => (
      <option key={index} value={empresa}>
        {empresa}
      </option>
    ));
  };
  const renderCategoriaClienteOptions = () =>
    ["A", "B", "C"].map((categoria, index) => (
      <div key={index} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`categoriaCliente${categoria}`}
          value={categoria}
          checked={filtroCategoriaCliente.includes(categoria)}
          onChange={handleCategoriaClienteChange}
          style={{ marginLeft: "-35px" }}
        />
        <label className="form-check-label" htmlFor={`categoriaCliente${categoria}`} style={{ marginLeft: "0px" }}>
          {categoria}
        </label>
      </div>
    ));
  const handleCategoriaClienteChange = (e) => {
    const categoria = e.target.value;
    setFiltroCategoriaCliente((prev) =>
      prev.includes(categoria) ? prev.filter((c) => c !== categoria) : [...prev, categoria]
    );
  };
  const handleEstatusChange = (e) => {
    const value = e.target.value;
    setFiltroEstatus((prev) => (prev.includes(value) ? prev.filter((estatus) => estatus !== value) : [...prev, value]));
  };
  const handleFlashEdit = (oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id);
    if (!cliente) {
      toast.error("No se encontró el cliente asociado a esta oportunidad.");
      return;
    }
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" &&
        !(cliente.ejecutivos_asignados?.includes(Number(id)) || String(id) === String(oportunidad.ejecutivo)))
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    setFlashEditingOpportunity(oportunidad);
    setIsFlashEditing(true);
  };
  const onSubmitFlashEdit = async (data) => {
    try {
      setLoading(true);
      const cierreDate = new Date(`${data.ano_cierre}-${data.mes_cierre}-01`);
      const facturaDate = new Date(`${data.ano_factura}-${data.mes_factura}-01`);
      if (cierreDate > facturaDate) {
        toast.error("El mes y año de cierre debe ser igual o anterior al mes y año de facturación.");
        setLoading(false);
        return;
      }
      const updatedOportunidad = {
        estatus: data.estatus,
        mes_cierre: `${data.mes_cierre.padStart(2, "0")}-${data.ano_cierre}`,
        mes_factura: `${data.mes_factura.padStart(2, "0")}-${data.ano_factura}`,
        ano: parseInt(data.ano_factura, 10),
        updated_at: new Date().toISOString(),
      };
      await updateOportunidad({ id: flashEditingOpportunity.id, oportunidad: updatedOportunidad });
      toast.success("Oportunidad actualizada correctamente");
      const updatedOportunidades = todasLasOportunidades.map((op) =>
        op.id === flashEditingOpportunity.id ? { ...op, ...updatedOportunidad } : op
      );
      setTodasLasOportunidades(updatedOportunidades);
      const clienteMatch = clientes.find((c) => c.id === flashEditingOpportunity.client_id);
      if (clienteMatch) {
        const updatedClientes = clientes.map((cliente) =>
          cliente.id === flashEditingOpportunity.client_id ? { ...cliente, ...updatedOportunidad } : cliente
        );
        setClientesPublicitarios(updatedClientes);
        const [newVentasCliente, newVentasYTD, newVentasHTD] = calculateVentasYOportunidades(
          updatedOportunidades,
          todasLasOportunidadesBTL,
          updatedClientes,
          CURRENT_YEAR
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: newVentasCliente,
          ventasYTD: newVentasYTD,
          ventasHTD: newVentasHTD,
        }));
      }
      setIsFlashEditing(false);
      setFlashEditingOpportunity(null);
    } catch (error) {
      console.error("Error updating oportunidad:", error);
      toast.error("Error al actualizar la oportunidad");
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id);
    if (!cliente) {
      toast.error("No se encontró el cliente asociado a esta oportunidad.");
      return;
    }
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" &&
        !(cliente.ejecutivos_asignados?.includes(Number(id)) || String(id) === String(oportunidad.ejecutivo)))
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    if (pais === "Perú" || pais === "Chile") {
      if (isEditableByDate(oportunidad.created_at)) {
        navigate(`/admin/online-cotizador/editar/${oportunidad.id}`, { state: { oportunidad } });
      } else {
        setSelectedClienteId(oportunidad.client_id);
        setSelectedOportunidadId(oportunidad.id);
        setIsModalOpen(true);
      }
    } else {
      console.warn("Edición no soportada para el país:", pais);
      toast.info("Edición no disponible para este país.");
    }
  };
  const renderEstatusOptions = () =>
    ["100%", "90%", "75%", "50%", "0%", "sinPropuesta"].map((estatus, index) => (
      <div key={index} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`estatus${index}`}
          value={estatus}
          checked={filtroEstatus.includes(estatus)}
          onChange={handleEstatusChange}
          style={{ marginLeft: "-35px" }}
        />
        <label className="form-check-label" htmlFor={`estatus${index}`} style={{ marginLeft: "0px" }}>
          {estatus === "sinPropuesta" ? "Sin Propuesta" : estatus}
        </label>
      </div>
    ));
  const renderCategoriaOptions = () =>
    categorias.map((categoria, index) => (
      <option key={index} value={categoria.id}>
        {categoria.nombre}
      </option>
    ));
  const handleCategoriaChange = (e) => {
    setFiltroCategoria(e.target.value);
  };
  const handleUpdateCliente = async (
    clienteId,
    newEjecutivo, // Este parámetro ya no se usará
    newAgencia,
    ultimoFechaCliente,
    ultimoAccionCliente,
    proximoFechaCliente,
    proximoAccionCliente,
    ultimoFechaAgencia,
    ultimoAccionAgencia,
    proximoFechaAgencia,
    proximoAccionAgencia,
    newContactoClienteId,
    newContactoAgenciaId,
    newTipo
  ) => {
    try {
      const cliente = clientes.find((c) => c.id === clienteId);
      if (!cliente) throw new Error("Cliente no encontrado");
      const updatedData = { id: clienteId };

      // Actualizar solo si hay cambios en las fechas o acciones de contacto
      if (
        ultimoFechaCliente !== null ||
        ultimoAccionCliente !== null ||
        proximoFechaCliente !== null ||
        proximoAccionCliente !== null
      ) {
        updatedData.ultimo_contacto_fecha_cliente =
          ultimoFechaCliente instanceof Date
            ? ultimoFechaCliente.toISOString().split("T")[0]
            : ultimoFechaCliente || cliente.ultimo_contacto_fecha_cliente;
        updatedData.ultimo_contacto_accion_cliente = ultimoAccionCliente || cliente.ultimo_contacto_accion_cliente;
        updatedData.proximo_contacto_fecha_cliente =
          proximoFechaCliente instanceof Date
            ? proximoFechaCliente.toISOString().split("T")[0]
            : proximoFechaCliente || cliente.proximo_contacto_fecha_cliente;
        updatedData.proximo_contacto_accion_cliente = proximoAccionCliente || cliente.proximo_contacto_accion_cliente;
      }
      if (
        ultimoFechaAgencia !== null ||
        ultimoAccionAgencia !== null ||
        proximoFechaAgencia !== null ||
        proximoAccionAgencia !== null
      ) {
        updatedData.ultimo_contacto_fecha_agencia =
          ultimoFechaAgencia instanceof Date
            ? ultimoFechaAgencia.toISOString().split("T")[0]
            : ultimoFechaAgencia || cliente.ultimo_contacto_fecha_agencia;
        updatedData.ultimo_contacto_accion_agencia = ultimoAccionAgencia || cliente.ultimo_contacto_accion_agencia;
        updatedData.proximo_contacto_fecha_agencia =
          proximoFechaAgencia instanceof Date
            ? proximoFechaAgencia.toISOString().split("T")[0]
            : proximoFechaAgencia || cliente.proximo_contacto_fecha_agencia;
        updatedData.proximo_contacto_accion_agencia = proximoAccionAgencia || cliente.proximo_contacto_accion_agencia;
      }

      // Actualizar otros campos solo si se proporcionan, sin tocar ejecutivo ni ejecutivos_asignados
      if (newAgencia !== undefined && newAgencia !== null) updatedData.agencia = newAgencia;
      if (newContactoClienteId !== null) {
        updatedData.contactoId = newContactoClienteId;
        updatedData.contacto_cliente = newContactoClienteId;
      }
      if (newContactoAgenciaId !== null) updatedData.contacto_agencia = newContactoAgenciaId;
      if (newTipo !== "" && newTipo !== null) updatedData.categoria_cliente = newTipo;

      await updateCliente(updatedData);
      setClientesPublicitarios(
        clientes.map((cliente) => (cliente.id === clienteId ? { ...cliente, ...updatedData } : cliente))
      );
      setEditingClienteId(null);
      setEditingClienteContact(null);
      setEditingAgenciaContact(null);
      setUltimoContactoFechaCliente(null);
      setUltimoContactoAccionCliente("");
      setProximoContactoFechaCliente(null);
      setProximoContactoAccionCliente("");
      setUltimoContactoFechaAgencia(null);
      setUltimoContactoAccionAgencia("");
      setProximoContactoFechaAgencia(null);
      setProximoContactoAccionAgencia("");
      setTipoCliente("");
      toast.success("Datos guardados exitosamente");
    } catch (error) {
      console.error("Error updating cliente:", error.message);
      toast.error("Error al guardar los datos: " + error.message);
    }
  };
  const handleUpdateStatus = async (clienteId, oportunidadId, newStatus) => {
    try {
      const allowedStatuses = ["100%", "90%", "75%", "50%", "0%"];
      if (!allowedStatuses.includes(newStatus)) throw new Error("Estatus no válido");
      const oportunidad = todasLasOportunidades.find((op) => op.id === oportunidadId);
      if (!oportunidad) throw new Error("No se encontró la oportunidad para el cliente seleccionado");
      const currentYear = new Date().getFullYear().toString();
      const updateData = {
        estatus: newStatus,
        updated_at: new Date().toISOString(),
        mes_cierre:
          oportunidad.mes_cierre || `${(new Date().getMonth() + 1).toString().padStart(2, "0")}-${currentYear}`,
        mes_factura:
          oportunidad.mes_factura || `${(new Date().getMonth() + 1).toString().padStart(2, "0")}-${currentYear}`,
        ano: oportunidad.mes_factura ? parseInt(oportunidad.mes_factura.split("-")[1], 10) : parseInt(currentYear, 10),
      };
      const response = await updateOportunidad({ id: oportunidadId, oportunidad: updateData });
      if (!response || response.error || response.length === 0)
        throw new Error(response.error?.message || "No se pudo actualizar la oportunidad");
      const updatedOportunidades = todasLasOportunidades.map((op) =>
        op.id === oportunidadId ? { ...op, ...updateData } : op
      );
      setTodasLasOportunidades(updatedOportunidades);
      const clienteMatch = clientes.find((c) => c.id === clienteId);
      if (clienteMatch) {
        const updatedClientes = clientes.map((cliente) =>
          cliente.id === clienteId ? { ...cliente, ...updateData } : cliente
        );
        setClientesPublicitarios(updatedClientes);
        const [newVentasCliente, newVentasYTD, newVentasHTD] = calculateVentasYOportunidades(
          updatedOportunidades,
          todasLasOportunidadesBTL,
          updatedClientes,
          CURRENT_YEAR
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: newVentasCliente,
          ventasYTD: newVentasYTD,
          ventasHTD: newVentasHTD,
        }));
      }
      toast.success("Estatus actualizado exitosamente");
    } catch (error) {
      console.error("Error al actualizar el estatus:", error.message);
      toast.error("Error al actualizar el estatus: " + error.message);
    }
  };

  const calcularSumasFiltradas = useCallback(
    debounce(() => {
      // Filtrar oportunidades basadas en facturafecha o mes_factura para facturación
      const filteredOportunidadesFact = filtrarOportunidadesMemo.filter((op) => {
        // Incluir si tiene facturafecha O mes_factura (igual que calcularPublicidadMensual)
        if (!op.facturafecha && !op.mes_factura) return false;
        return true;
      });
      const filteredOportunidadesBTLFact = todasLasOportunidadesBTLMemo.filter((btl) => {
        if (!btl.facturafecha && !btl.mes_factura) return false; // Incluir si tiene facturafecha O mes_factura
        const cliente = clientesMemo.find((c) => c.id === btl.client_id);
        const intermediarioId = cliente ? cliente.agencia : null;
        const matchesIntermediario = matchAgenciaFilter(filtroIntermediario, intermediarioId, pais);
        const clienteNombre = cliente ? cliente.empresa.toLowerCase() : "";
        const clienteProducto = cliente ? cliente.producto : "";
        const mesFacturaStr = btl.mes_factura?.split("-")?.[0] || null;
        const estatus = btl.status === 100 ? "100%" : `${btl.status || 0}%`;
        return (
          btl.pais === pais &&
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesFacturaStr && filtroMes.includes(mesFacturaStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(estatus)) &&
          matchesIntermediario &&
          (!filtroCategoria || (cliente && clienteCategoriaMap[btl.client_id] === filtroCategoria)) &&
          (!filtroEjecutivo || (btl.ejecutivo != null && String(btl.ejecutivo) === filtroEjecutivo))
        );
      });

      // Filtrar oportunidades basadas en mes_cierre para cierres (sin depender del filtro mes_factura)
      const filteredOportunidadesCierre = todasLasOportunidadesMemo.filter((oportunidad) => {
        if (!oportunidad.mes_cierre) return false;
        const clienteMatch = clientesMemo.find((c) => c.id === oportunidad.client_id);
        const intermediarioId = clienteMatch ? clienteMatch.agencia : null;
        const matchesIntermediario = matchAgenciaFilter(filtroIntermediario, intermediarioId, pais);
        const clienteCategoria = clienteMatch ? clienteMatch.categoria : null;
        const clienteNombre = clienteMatch ? clienteMatch.empresa.toLowerCase() : "";
        const clienteProducto = clienteMatch ? clienteMatch.producto : "";
        const matchesEjecutivo =
          !filtroEjecutivo ||
          clienteMatch?.ejecutivos_asignados?.includes(Number(filtroEjecutivo)) ||
          String(clienteMatch?.ejecutivo) === String(filtroEjecutivo);
        // Para cierres, filtrar por mes_cierre (no mes_factura)
        const mesCierreStr = oportunidad.mes_cierre?.split("-")?.[0] || null;
        return (
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesCierreStr && filtroMes.includes(mesCierreStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(oportunidad.estatus || "0%")) &&
          matchesIntermediario &&
          (filtroCategoria === "" || (clienteCategoria && parseInt(clienteCategoria) === parseInt(filtroCategoria))) &&
          matchesEjecutivo
        );
      });
      const filteredOportunidadesBTLCierre = todasLasOportunidadesBTLMemo.filter((btl) => {
        if (!btl.mes_cierre) return false;
        const cliente = clientesMemo.find((c) => c.id === btl.client_id);
        const intermediarioId = cliente ? cliente.agencia : null;
        const matchesIntermediario = matchAgenciaFilter(filtroIntermediario, intermediarioId, pais);
        const clienteNombre = cliente ? cliente.empresa.toLowerCase() : "";
        const clienteProducto = cliente ? cliente.producto : "";
        const estatus = btl.status === 100 ? "100%" : `${btl.status || 0}%`;
        // Para cierres BTL, filtrar por mes_cierre (no mes_factura)
        const mesCierreStr = btl.mes_cierre?.split("-")?.[0] || null;
        return (
          btl.pais === pais &&
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesCierreStr && filtroMes.includes(mesCierreStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(estatus)) &&
          matchesIntermediario &&
          (!filtroCategoria || (cliente && clienteCategoriaMap[btl.client_id] === filtroCategoria)) &&
          (!filtroEjecutivo || (btl.ejecutivo != null && String(btl.ejecutivo) === filtroEjecutivo))
        );
      });

      // Calcular sumas con los datos filtrados
      const { sumCierres } = calculateSalesSums(
        filteredOportunidadesCierre,
        filteredOportunidadesBTLCierre,
        CURRENT_YEAR, // ✅ Cambiar de "2025" a CURRENT_YEAR
        1,
        12,
        getTasaCambio(),
        pais
      );

      const { sumaImportes100, sumaImportes90, sumaImportes75, sumaImportes50, sumaImportes0 } = calculateSalesSums(
        filteredOportunidadesFact,
        filteredOportunidadesBTLFact,
        CURRENT_YEAR, // ✅ Cambiar de "2025" a CURRENT_YEAR
        1,
        12,
        getTasaCambio(),
        pais
      );

      setSumasFiltradas({
        "100%": sumaImportes100,
        "90%": sumaImportes90,
        "75%": sumaImportes75,
        "50%": sumaImportes50,
        "0%": sumaImportes0,
      });
      setSumCierres(sumCierres);

      // Actualizar ventasPorCliente con calculateVentasYOportunidades
      const [newVentasCliente, newVentasYTD, newVentasHTD] = calculateVentasYOportunidades(
        filteredOportunidadesFact,
        filteredOportunidadesBTLFact,
        clientesMemo,
        CURRENT_YEAR
      );
      setVentasData((prev) => ({
        ...prev,
        ventasPorCliente: newVentasCliente,
        ventasYTD: newVentasYTD,
        ventasHTD: newVentasHTD,
      }));
    }, 300),
    [
      filtrarOportunidadesMemo,
      todasLasOportunidadesMemo,
      todasLasOportunidadesBTLMemo,
      filtroCliente,
      filtroProducto,
      filtroMes,
      filtroEstatus,
      filtroIntermediario,
      filtroCategoria,
      filtroEjecutivo,
      pais,
      clientesMemo,
      clienteCategoriaMap,
      categorias,
    ]
  );

  useEffect(() => {
    calcularSumasFiltradas();
  }, [calcularSumasFiltradas]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const paisCode = getPaisCode(pais);
        const [
          categoriasData,
          clientesData,
          intermediariosData,
          oportunidadesData,
          usuariosData,
          oportunidadesBTLData,
        ] = await Promise.all([
          getCategorias(),
          getClientes({ pais: paisCode, orderBy: "nombre", ascending: true }),
          getIntermediarios({ pais: paisCode }),
          getOportunidades({ pais: paisCode }),
          getUsers(),
          getOportunidadesBTL({ pais: paisCode }),
        ]);
        // Normalizar igual que VentasProyeccion
        const oportunidadesNoEliminadas = oportunidadesData
          .filter((oportunidad) => !oportunidad.eliminada)
          .map((oportunidad) => ({
            ...oportunidad,
            mes_cierre: normalizeMonth(oportunidad.mes_cierre, oportunidad.created_at, oportunidad.ano),
            mes_factura: normalizeMonth(oportunidad.mes_factura, oportunidad.created_at, oportunidad.ano),
          }));
        setTodasLasOportunidades(oportunidadesNoEliminadas);
        const oportunidadesBTLNoEliminadas = oportunidadesBTLData
          .filter((btl) => !btl.eliminada && btl.pais === pais)
          .map((btl) => ({
            ...btl,
            mes_cierre: normalizeMonth(btl.mes_cierre, btl.created_at, btl.ano),
            mes_factura: normalizeMonth(btl.mes_factura, btl.created_at, btl.ano),
          }));
        setTodasLasOportunidadesBTL(oportunidadesBTLNoEliminadas);
        setCategorias(categoriasData);
        const filteredClientes = clientesData;
        const [ventasCliente, ventasYTD, ventasHTD] = calculateVentasYOportunidades(
          oportunidadesNoEliminadas,
          oportunidadesBTLNoEliminadas,
          filteredClientes,
          CURRENT_YEAR
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: ventasCliente,
          ventasYTD: ventasYTD,
          ventasHTD: ventasHTD,
        }));
        setClientesPublicitarios(filteredClientes);
        setIntermediarios(intermediariosData);
        setUsuarios(usuariosData);
        setLoading(false);
      } catch (error) {
        console.error("Error al inicializar datos:", error);
        toast.error("Hubo un error al cargar los datos. Inténtalo de nuevo.");
        setLoading(false);
      }
    };
    fetchData();
  }, [pais]);

  useEffect(() => {
    calcularSumasFiltradas();
  }, [calcularSumasFiltradas]);

  useEffect(() => {
    const [newVentasCliente, newVentasYTD, newVentasHTD] = calculateVentasYOportunidades(
      filtrarOportunidadesMemo,
      todasLasOportunidadesBTLMemo,
      clientesMemo,
      CURRENT_YEAR
    );
    setVentasData((prev) => ({
      ...prev,
      ventasPorCliente: newVentasCliente,
      ventasYTD: newVentasYTD,
      ventasHTD: newVentasHTD,
    }));
  }, [filtrarOportunidadesMemo, todasLasOportunidadesBTLMemo, clientesMemo]);

  const getContactoPriority = (
    cliente,
    today,
    todayDate,
    tomorrowDate,
    startOfCurrentWeek,
    endOfCurrentWeek,
    startOfNextWeek,
    endOfNextWeek,
    fifteenDaysFromNow
  ) => {
    const proximoContactoCliente = parseLocalDate(cliente.proximo_contacto_fecha_cliente);
    const proximoContactoAgencia = parseLocalDate(cliente.proximo_contacto_fecha_agencia);
    let proximoContactoDate = proximoContactoCliente;
    if (proximoContactoAgencia && (!proximoContactoCliente || proximoContactoAgencia < proximoContactoCliente)) {
      proximoContactoDate = proximoContactoAgencia;
    } else if (!proximoContactoCliente && !proximoContactoAgencia) return 999;
    if (!proximoContactoDate || isNaN(proximoContactoDate.getTime())) return 999;
    if (proximoContactoDate < today) return 1;
    if (
      proximoContactoDate.getFullYear() === todayDate.getFullYear() &&
      proximoContactoDate.getMonth() === todayDate.getMonth() &&
      proximoContactoDate.getDate() === todayDate.getDate()
    )
      return 2;
    if (
      proximoContactoDate.getFullYear() === tomorrowDate.getFullYear() &&
      proximoContactoDate.getMonth() === tomorrowDate.getMonth() &&
      proximoContactoDate.getDate() === tomorrowDate.getDate()
    )
      return 3;
    if (
      proximoContactoDate >= startOfCurrentWeek &&
      proximoContactoDate <= endOfCurrentWeek &&
      proximoContactoDate >= today
    )
      return 4;
    if (proximoContactoDate >= startOfNextWeek && proximoContactoDate <= endOfNextWeek) return 5;
    if (proximoContactoDate >= fifteenDaysFromNow) return 6;
    return 7;
  };
  const getDaysSinceCreation = (createdAt) => {
    if (!createdAt) return "-";
    const createdDate = new Date(createdAt);
    if (isNaN(createdDate.getTime())) return "-";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const createdDay = new Date(createdDate.getFullYear(), createdDate.getMonth(), createdDate.getDate());
    const todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const diffTime = todayDay - createdDay;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays === 0 ? "0 días" : `${diffDays} día${diffDays > 1 ? "s" : ""}`;
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayDate = new Date(today);
  const tomorrowDate = new Date(today);
  tomorrowDate.setDate(today.getDate() + 1);
  const todayDayOfWeek = today.getDay();
  const startOfCurrentWeek = new Date(today);
  startOfCurrentWeek.setDate(today.getDate() - (todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1));
  const endOfCurrentWeek = new Date(startOfCurrentWeek);
  endOfCurrentWeek.setDate(startOfCurrentWeek.getDate() + 6);
  const startOfNextWeek = new Date(startOfCurrentWeek);
  startOfNextWeek.setDate(startOfCurrentWeek.getDate() + 7);
  const endOfNextWeek = new Date(startOfNextWeek);
  endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
  const fifteenDaysFromNow = new Date(today);
  fifteenDaysFromNow.setDate(today.getDate() + 15);
  const mapOrdenamientoToText = (value) =>
    ({
      contactar: "Contactar!",
      hoy: "Hoy",
      mañana: "Mañana",
      estaSemana: "Esta semana",
      proximaSemana: "Próxima semana",
      mas15Dias: "15 días o más",
    })[value] || "";
  const renderEjecutivosOptions = () => {
    const countryMapping = { Uruguay: "URU", Perú: "PER", Chile: "CHI" };
    const countryCode = countryMapping[pais] || "";
    const ejecutivosUnicos = usuarios
      .filter((user) => {
        const userPais = user.pais || "";
        const userRol = user.rol ? user.rol.toLowerCase().trim() : "";
        const validRoles = ["comercial", "gerencia"].map((r) => r.toLowerCase());
        return (userPais === countryCode || !countryCode) && validRoles.includes(userRol) && user.habilitado === true;
      })
      .sort((a, b) => `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`));
    return ejecutivosUnicos.map((usuario, index) => (
      <option key={index} value={usuario.id}>
        {`${usuario.nombre} ${usuario.apellido}`}
      </option>
    ));
  };
  const getRadius = (key, data) => {
    const keys = Object.keys(data).filter((key) => data[key] > 0);
    const firstKey = keys[0];
    const lastKey = keys.at(-1);
    if (firstKey === key && lastKey === key) return [10, 10, 10, 10];
    else if (firstKey === key) return [10, 0, 0, 10];
    else if (lastKey === key) return [0, 10, 10, 0];
    return [0, 0, 0, 0];
  };
  const getBootstrapClassForStatus = (status) => {
    switch (status) {
      case "100%":
        return "bg-success";
      case "90%":
        return "bg-danger";
      case "75%":
        return "bg-primary";
      case "50%":
        return "bg-warning";
      case "0%":
        return "bg-black";
      default:
        return "bg-secondary";
    }
  };
  const getColorForStatus = (status) => {
    switch (status) {
      case "100%":
        return "#198754";
      case "90%":
        return "#dc3545";
      case "75%":
        return "#0d6efd";
      case "50%":
        return "#ffc107";
      case "0%":
        return "#000000";
      default:
        return "#555555";
    }
  };
  const getLabelColorForStatus = (status) => (status === "50%" ? "#000" : "#fff");
  useEffect(() => {
    const newData = [
      {
        name: "Total",
        "100%": (sumasFiltradas["100%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "90%": (sumasFiltradas["90%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "75%": (sumasFiltradas["75%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "50%": (sumasFiltradas["50%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "0%": (sumasFiltradas["0%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        empty: Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) === 0 ? 100 : 0,
      },
    ];
    setData(newData);
  }, [sumasFiltradas]);
  useEffect(() => {
    if (flashEditingOpportunity) {
      const mesCierreValue = flashEditingOpportunity.mes_cierre
        ? flashEditingOpportunity.mes_cierre.split("-")[0]
        : "01";
      const anoCierreValue = flashEditingOpportunity.mes_cierre
        ? flashEditingOpportunity.mes_cierre.split("-")[1]
        : new Date().getFullYear().toString();
      const mesFacturaValue = flashEditingOpportunity.mes_factura
        ? flashEditingOpportunity.mes_factura.split("-")[0]
        : "01";
      const anoFacturaValue = flashEditingOpportunity.mes_factura
        ? flashEditingOpportunity.mes_factura.split("-")[1]
        : new Date().getFullYear().toString();
      reset({
        estatus: flashEditingOpportunity.estatus || "",
        mes_cierre: mesCierreValue,
        ano_cierre: anoCierreValue,
        mes_factura: mesFacturaValue,
        ano_factura: anoFacturaValue,
      });
    }
  }, [flashEditingOpportunity, reset]);
  const parseLocalDate = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };
  const filtrarClientes = useCallback(() => {
    let filteredClientes = clientes.filter((cliente) => {
      const matchesAgencia = matchAgenciaFilter(filtroIntermediario, cliente.agencia, pais);
      const clienteMatch = !filtroCliente || cliente.empresa.toLowerCase().includes(filtroCliente.toLowerCase());
      const productoMatch = !filtroProducto || cliente.producto === filtroProducto;
      const categoriaClienteMatch =
        filtroCategoriaCliente.length === 0 || filtroCategoriaCliente.includes(cliente.categoria_cliente);
      const categoriaMatch =
        filtroCategoria === "" || (cliente.categoria && parseInt(cliente.categoria) === parseInt(filtroCategoria));
      const mesMatch =
        filtroMes.length === 0 ||
        [...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
          (op) => op.client_id === cliente.id && filtroMes.includes(op.mes_factura?.split("-")?.[0] || "01")
        );
      const estatusMatch =
        filtroEstatus.length === 0 ||
        (filtroEstatus.includes("sinPropuesta") &&
          ![...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
            (op) =>
              op.client_id === cliente.id &&
              (op.estatus === "90%" ||
                op.estatus === "75%" ||
                op.estatus === "50%" ||
                (op.status < 100 && op.status > 0))
          )) ||
        [...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
          (op) => op.client_id === cliente.id && filtroEstatus.includes(op.estatus || `${op.status}%`)
        );
      const proximoClienteText = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
      const proximoAgenciaText = getDaysDifference(cliente.proximo_contacto_fecha_agencia, true);
      const clienteProximoDate = parseLocalDate(cliente.proximo_contacto_fecha_cliente);
      const agenciaProximoDate = parseLocalDate(cliente.proximo_contacto_fecha_agencia);
      const matchesProximoContacto = (() => {
        if (!ordenamiento.porFecha || ordenamiento.porFecha === "null") return true;
        const ordenValue = ordenamiento.porFecha;
        const targetText = mapOrdenamientoToText(ordenValue);
        if (ordenValue === "estaSemana") {
          const isClienteEstaSemana =
            clienteProximoDate && clienteProximoDate >= startOfCurrentWeek && clienteProximoDate <= endOfCurrentWeek;
          const isAgenciaEstaSemana =
            agenciaProximoDate && agenciaProximoDate >= startOfCurrentWeek && agenciaProximoDate <= endOfCurrentWeek;
          return isClienteEstaSemana || isAgenciaEstaSemana;
        }
        if (ordenValue === "proximaSemana") {
          const isClienteProxSemana =
            clienteProximoDate && clienteProximoDate >= startOfNextWeek && clienteProximoDate <= endOfNextWeek;
          const isAgenciaProxSemana =
            agenciaProximoDate && agenciaProximoDate >= startOfNextWeek && agenciaProximoDate <= endOfNextWeek;
          return isClienteProxSemana || isAgenciaProxSemana;
        }
        return proximoClienteText === targetText || proximoAgenciaText === targetText;
      })();
      const usuarioMatch =
        !filtroUsuario ||
        [
          cliente.contacto_cliente,
          cliente.contacto_cliente_1,
          cliente.contacto_cliente_2,
          cliente.contacto_cliente_3,
          cliente.contacto_agencia,
          cliente.contacto_agencia_1,
          cliente.contacto_agencia_2,
          cliente.contacto_agencia_3,
        ].some((id) => String(id) === String(filtroUsuario));
      const matchesEjecutivo = !filtroEjecutivo || String(cliente.ejecutivo) === String(filtroEjecutivo);
      return (
        clienteMatch &&
        productoMatch &&
        categoriaMatch &&
        categoriaClienteMatch &&
        matchesAgencia &&
        mesMatch &&
        estatusMatch &&
        matchesProximoContacto &&
        usuarioMatch &&
        matchesEjecutivo
      );
    });
    filteredClientes = filteredClientes.sort((a, b) => {
      const oportunidades90A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "90%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      const oportunidades90B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "90%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      if (oportunidades90A !== oportunidades90B) return oportunidades90B - oportunidades90A;
      const oportunidades75A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "75%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      const oportunidades75B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "75%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      if (oportunidades75A !== oportunidades75B) return oportunidades75B - oportunidades75A;
      const oportunidades50A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "50%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      const oportunidades50B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "50%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      if (oportunidades50A !== oportunidades50B) return oportunidades50B - oportunidades50A;
      const oportunidades100A = ventasData.ventasPorCliente[a.id] || 0;
      const oportunidades100B = ventasData.ventasPorCliente[b.id] || 0;
      if (oportunidades100A !== oportunidades100B) return oportunidades100B - oportunidades100A;
      const oportunidades0A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "0%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      const oportunidades0B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "0%")
          .reduce((sum, op) => sum + convertirAMonedaLocal(op.importe || op.total_investment, op.moneda_dolar), 0) || 0;
      if (oportunidades0A !== oportunidades0B) return oportunidades0B - oportunidades0A;
      const dateA =
        parseLocalDate(a.proximo_contacto_fecha_cliente) || parseLocalDate(a.proximo_contacto_fecha_agencia);
      const dateB =
        parseLocalDate(b.proximo_contacto_fecha_cliente) || parseLocalDate(b.proximo_contacto_fecha_agencia);
      if (dateA && dateB && dateA.getTime() !== dateB.getTime()) {
        const priorityA = getContactoPriority(
          a,
          today,
          todayDate,
          tomorrowDate,
          startOfCurrentWeek,
          endOfCurrentWeek,
          startOfNextWeek,
          endOfNextWeek,
          fifteenDaysFromNow
        );
        const priorityB = getContactoPriority(
          b,
          today,
          todayDate,
          tomorrowDate,
          startOfCurrentWeek,
          endOfCurrentWeek,
          startOfNextWeek,
          endOfNextWeek,
          fifteenDaysFromNow
        );
        if (priorityA !== priorityB) return priorityA - priorityB;
        return dateA - dateB;
      }
      return a.empresa.localeCompare(b.empresa);
    });
    return filteredClientes;
  }, [
    clientes,
    filtroCategoria,
    filtroCategoriaCliente,
    filtroCliente,
    filtroEstatus,
    filtroIntermediario,
    filtroMes,
    todasLasOportunidades,
    todasLasOportunidadesBTL,
    filtroUsuario,
    filtroEjecutivo,
    ordenamiento.porFecha,
    ventasData.ventasPorCliente,
    today,
    todayDate,
    tomorrowDate,
    startOfCurrentWeek,
    endOfCurrentWeek,
    startOfNextWeek,
    endOfNextWeek,
    fifteenDaysFromNow,
    mapOrdenamientoToText,
    getDaysDifference,
    convertirAMonedaLocal,
    pais,
    getContactoPriority,
  ]);

  const filtersContent = (
    <div className={s.filtersContainer}>
      {/* Fila 1: Ejecutivo, Marca, Producto, Mes/meses, Status */}
      <div className={s.filterRow}>
        <div>
          <select
            className={`form-control ${filtroEjecutivo ? s.activeFilter : ""}`}
            value={filtroEjecutivo || ""}
            onChange={(e) => setFiltroEjecutivo(e.target.value)}
          >
            <option value="">Ejecutivo</option>
            {renderEjecutivosOptions()}
          </select>
        </div>
        <div>
          <select
            className={`form-control ${filtroCliente ? s.activeFilter : ""}`}
            value={filtroCliente || ""}
            onChange={(e) => setFiltroCliente(e.target.value)}
          >
            <option value="">Marca</option>
            {renderClientesOptions()}
          </select>
        </div>
        <div>
          <select
            className={`form-control ${filtroProducto ? s.activeFilter : ""}`}
            value={filtroProducto || ""}
            onChange={(e) => setFiltroProducto(e.target.value)}
            disabled={!filtroCliente || (filtroCliente && getProductosCount(filtroCliente) <= 1)}
          >
            <option value="">Producto</option>
            {renderProductosOptions()}
          </select>
        </div>
        <div>
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              id="dropdown-basic"
              className={`form-control text-start ${filtroMes.length > 0 ? s.activeFilter : ""}`}
            >
              {filtroMes.length > 0 ? filtroMes.map((mes) => mesEnLetras(mes)).join(", ") : "Mes/meses"}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderMesOptions()}</Dropdown.Menu>
          </Dropdown>
        </div>
        <div>
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              id="dropdown-status"
              className={`form-control text-start ${filtroEstatus.length > 0 ? s.activeFilter : ""}`}
            >
              {filtroEstatus.length > 0 ? filtroEstatus.join(", ") : "Status"}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderEstatusOptions()}</Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      {/* Fila 2: Categoría, Intermediario, Próximo Contacto, Usuario, Tipo Cliente */}
      <div className={s.filterRow}>
        <div>
          <select
            className={`form-control ${filtroCategoria ? s.activeFilter : ""}`}
            value={filtroCategoria}
            onChange={handleCategoriaChange}
          >
            <option value="">Categoría</option>
            {renderCategoriaOptions()}
          </select>
        </div>
        <div>
          <AgenciasDropdown
            value={filtroIntermediario}
            onChange={(e) => setFiltroIntermediario(e.target.value)}
            intermediarios={intermediarios}
            placeholder="Intermediario"
            className={`form-control ${filtroIntermediario ? s.activeFilter : ""}`}
          />
        </div>
        <div>
          <select
            className={`form-control ${ordenamiento.porFecha ? s.activeFilter : ""}`}
            value={ordenamiento.porFecha || ""}
            onChange={(e) => {
              setOrdenamiento({ ...ordenamiento, porFecha: e.target.value || null });
            }}
          >
            <option value="">Próximo Contacto</option>
            <option value="contactar">Vencidos</option>
            <option value="hoy">Hoy</option>
            <option value="mañana">Mañana</option>
            <option value="estaSemana">Esta semana</option>
            <option value="proximaSemana">Próxima semana</option>
            <option value="mas15Dias">15 días o más</option>
          </select>
        </div>
        <div>
          <select
            className={`form-control ${filtroUsuario ? s.activeFilter : ""}`}
            value={filtroUsuario || ""}
            onChange={(e) => setFiltroUsuario(e.target.value)}
          >
            <option value="">Usuario</option>
            {renderUsuariosOptions()}
          </select>
        </div>
        <div>
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              id="dropdown-categoria-cliente"
              className={`form-control text-start ${filtroCategoriaCliente.length > 0 ? s.activeFilter : ""}`}
            >
              {filtroCategoriaCliente.length > 0 ? filtroCategoriaCliente.join(", ") : "Tipo Cliente"}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderCategoriaClienteOptions()}</Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {loading ? (
        <div>Cargando...</div>
      ) : (
        <>
          {renderHeader ? renderHeader(filtersContent) : filtersContent}
          <div className={`mb-2 ${styles.cardsContainer}`}>
            <div className="d-flex justify-content-between">
              <div
                className="text-center p-2 border border-dark m-3 text-white"
                style={{ borderRadius: "5px", width: "200px", backgroundColor: "#6318a9ff" }}
              >
                <div>
                  <strong>Cierres {CURRENT_YEAR}</strong>
                </div>
                <div>{sumCierres > 0 ? formatMoneda(sumCierres) : "-"}</div>
              </div>
              {["100%", "90%", "75%", "50%", "0%"].map((estatus, index) => (
                <div
                  key={index}
                  className={`text-center p-2 ${getBootstrapClassForStatus(estatus)} border border-dark m-3 text-${
                    estatus === "50%" ? "dark" : "white"
                  }`}
                  style={{ borderRadius: "5px", width: "200px" }}
                >
                  <div>
                    <strong>{estatus === "100%" ? `Facturación ${CURRENT_YEAR}` : estatus}</strong>
                  </div>
                  <div>{sumasFiltradas[estatus] > 0 ? formatMoneda(sumasFiltradas[estatus]) : "-"}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.chartContainer}>
            <ResponsiveContainer width="100%" height={80} className="p-0 m-0">
              <BarChart layout="vertical" data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                <XAxis type="number" domain={[0, 100]} tick={false} axisLine={false} />
                <YAxis type="category" dataKey="name" hide />
                {data[0].empty > 0 ? (
                  <Bar dataKey="empty" fill="#555555" isAnimationActive={false} radius={[10, 10, 10, 10]}>
                    <LabelList
                      dataKey="empty"
                      position="center"
                      formatter={() => "Sin propuestas asociadas :("}
                      fill="#FFF"
                    />
                  </Bar>
                ) : (
                  ["100%", "90%", "75%", "50%", "0%"].map(
                    (estatus) =>
                      data[0][estatus] > 0 && (
                        <Bar
                          key={estatus}
                          dataKey={estatus}
                          stackId="a"
                          fill={getColorForStatus(estatus)}
                          radius={getRadius(estatus, data[0])}
                        >
                          <LabelList
                            dataKey={estatus}
                            position="center"
                            formatter={(value) => `${Math.round(value)}%`}
                            fill={getLabelColorForStatus(estatus)}
                          />
                        </Bar>
                      )
                  )
                )}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <table id="ventas-table" className={`${styles.ventasTable} table table-bordered`}>
            <thead>
              <tr>
                <th rowSpan={2} className="text-center col-cliente">{toUpperCase("CLIENTE/PROSPECT")}</th>
                <th rowSpan={2} className="text-center col-ejecutivos">{toUpperCase("EJECUTIVOS ASIGNADOS")}</th>
                <th rowSpan={2} className="text-center col-oportunidad">{toUpperCase("OPORTUNIDADES")}</th>
                <th rowSpan={2} className="text-center col-contacto">{toUpperCase("CONTACTO")}</th>
                <th rowSpan={2} colSpan="2" className="text-center col-ultimo">
                  {toUpperCase("ÚLTIMO CONTACTO")}
                </th>
                <th rowSpan={2} colSpan="2" className="text-center col-proximo">
                  {toUpperCase("PRÓXIMO CONTACTO")}
                </th>
                <th rowSpan={2} className="text-center col-edit">{toUpperCase("EDIT")}</th>
                <th rowSpan={2} className="text-center col-tipo">{toUpperCase("TIPO")}</th>
                <th colSpan="2" className="text-center col-importes status-100">{toUpperCase("Facturación")}</th>
              </tr>
              <tr>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>{toUpperCase("YTD")}</th>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>{toUpperCase("HTD")}</th>
              </tr>
            </thead>
            {filtrarClientes().length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="11" className="text-center">
                    No hay data según los filtros seleccionados :(
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {filtrarClientes().map((cliente, index) => {
                  const isOdd = index % 2 === 0;
                  const agenciaContacts = sortContacts(
                    [
                      cliente.contacto_agencia,
                      cliente.contacto_agencia_1,
                      cliente.contacto_agencia_2,
                      cliente.contacto_agencia_3,
                    ],
                    usuarios,
                    "agencia",
                    ["Director de cuenta", "Supervisor de cuenta", "Planificador", "Asistente"]
                  );
                  const clienteContacts = sortContacts(
                    [
                      cliente.contacto_cliente,
                      cliente.contacto_cliente_1,
                      cliente.contacto_cliente_2,
                      cliente.contacto_cliente_3,
                    ],
                    usuarios,
                    "cliente",
                    [
                      "Director de marketing",
                      "Gerente de marketing",
                      "Subgerente de marketing",
                      "Brand manager",
                      "Jefe de medios",
                      "Asistente de marketing",
                    ]
                  );
                  const ventasMoneda = todasLasOportunidades
                    .filter((op) => op.client_id === cliente.id && op.estatus === "100%")
                    .every((op) => op.moneda_dolar)
                    ? "US$"
                    : getMonedaSymbol();
                  return (
                    <React.Fragment key={`pair-${index}`}>
                      <tr
                        className={isOdd ? styles.oddPair : styles.evenPair}
                        data-pair-index={index}
                        data-bg={isOdd ? "odd" : "even"}
                      >
                        <td
                          className="text-start"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}
                        >
                          <strong style={{ fontSize: "1.1rem" }}>{toUpperCase(cliente.empresa)}</strong>
                          <br />
                          {cliente.empresa !== cliente.producto && (
                            <>
                              <span style={{ fontSize: "1.0rem" }}>{toUpperCase(cliente.producto || "")}</span>
                              <br />
                            </>
                          )}
                          {(() => {
                            const clientOpportunities = [...todasLasOportunidades, ...todasLasOportunidadesBTL]
                              .filter(
                                (op) =>
                                  op.client_id === cliente.id &&
                                  (op.estatus === "90%" ||
                                    op.estatus === "75%" ||
                                    op.estatus === "50%" ||
                                    (op.status < 100 && op.status > 0))
                              )
                              .sort((a, b) => {
                                const priority = { "90%": 0, "75%": 1, "50%": 2 };
                                const priA = priority[a.estatus || `${a.status}%`] ?? 3;
                                const priB = priority[b.estatus || `${b.status}%`] ?? 3;
                                if (priA !== priB) return priA - priB;
                                const importeA = convertirAMonedaLocal(
                                  a.importe || a.total_investment,
                                  a.moneda_dolar,
                                  pais
                                );
                                const importeB = convertirAMonedaLocal(
                                  b.importe || b.total_investment,
                                  b.moneda_dolar,
                                  pais
                                );
                                return importeB - importeA;
                              });
                            return clientOpportunities.length > 0 ? (
                              <span style={{ fontSize: "0.85rem" }}>
                                {toUpperCase(clientOpportunities[0].campana || "")}
                              </span>
                            ) : (
                              <span style={{ fontSize: "0.85rem" }} />
                            );
                          })()}
                        </td>
                        <td
                          className="text-start"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}
                        >
                          {(() => {
                            const ejecutivos =
                              cliente.ejecutivos_asignados?.length > 0
                                ? cliente.ejecutivos_asignados
                                : [cliente.ejecutivo];
                            const ejecutivosUsuarios = sortContacts(
                              ejecutivos.filter((id) => id && usuarios.find((user) => String(user.id) === String(id))),
                              usuarios,
                              "ejecutivo",
                              ["Gerente", "Comercial", "Asistente"]
                            );
                            return ejecutivosUsuarios.length > 0 ? (
                              ejecutivosUsuarios.map((user, idx) => (
                                <div key={idx} style={{ marginBottom: "2px" }}>
                                  {`${user.nombre} ${user.apellido}`}
                                </div>
                              ))
                            ) : (
                              <div>-</div>
                            );
                          })()}
                        </td>
                        <td
                          className="text-end"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", position: "relative" }}
                        >
                          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            {(() => {
                              const clientOpportunities = [...todasLasOportunidades, ...todasLasOportunidadesBTL]
                                .filter(
                                  (op) =>
                                    op.client_id === cliente.id &&
                                    (op.estatus === "90%" ||
                                      op.estatus === "75%" ||
                                      op.estatus === "50%" ||
                                      (op.status < 100 && op.status > 0))
                                )
                                .sort((a, b) => {
                                  const priority = { "90%": 0, "75%": 1, "50%": 2 };
                                  const priA = priority[a.estatus || `${a.status}%`] ?? 3;
                                  const priB = priority[b.estatus || `${b.status}%`] ?? 3;
                                  if (priA !== priB) return priA - priB;
                                  const importeA = convertirAMonedaLocal(
                                    a.importe || a.total_investment,
                                    a.moneda_dolar,
                                    pais
                                  );
                                  const importeB = convertirAMonedaLocal(
                                    b.importe || b.total_investment,
                                    b.moneda_dolar,
                                    pais
                                  );
                                  return importeB - importeA;
                                });
                              return clientOpportunities.length > 0
                                ? clientOpportunities.map((oportunidad, index) => (
                                  <React.Fragment key={`oportunidad-${cliente.id}-${oportunidad.id}`}>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        gap: "2px",
                                      }}
                                    >
                                      <span
                                        className={styles.badgeOportunidad}
                                        style={{
                                          color: getColorForStatus(oportunidad.estatus || `${oportunidad.status}%`),
                                        }}
                                      >
                                        {formatMoneda(
                                          oportunidad.importe || oportunidad.total_investment,
                                          oportunidad.moneda_dolar
                                        )}
                                      </span>
                                      <div className={styles.daysSinceCreation}>
                                        {getDaysSinceCreation(oportunidad.created_at)}
                                      </div>
                                      {(rol === "superadmin" ||
                                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                                          (rol === "gerencia" &&
                                            (cliente.ejecutivos_asignados?.includes(Number(id)) ||
                                              String(id) === String(cliente.ejecutivo))) ||
                                          (rol === "comercial" &&
                                            (cliente.ejecutivos_asignados?.includes(Number(id)) ||
                                              String(id) === String(cliente.ejecutivo)))) && (
                                        <div style={{ display: "flex", gap: "5px" }}>
                                          <TiFlash
                                            style={{ cursor: "pointer", fontSize: "1rem", color: "#555" }}
                                            onClick={() => handleFlashEdit(oportunidad)}
                                          />
                                          <FaEdit
                                            style={{ cursor: "pointer", fontSize: "1rem", color: "#555" }}
                                            onClick={() => handleEdit(oportunidad)}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {index < clientOpportunities.length - 1 && clientOpportunities.length >= 2 && (
                                      <hr
                                        style={{
                                          width: "95%",
                                          margin: "5px 1px auto",
                                          borderTop: "1px solid #999",
                                          opacity: 0.5,
                                        }}
                                      />
                                    )}
                                  </React.Fragment>
                                ))
                                : "-";
                            })()}
                          </div>
                        </td>
                        <td
                          className="text-start"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "top" }}
                        >
                          {cliente.agencia && ![16, 32, 60].includes(Number(cliente.agencia)) ? (
                            <>
                              <div className="fw-bold">{getIntermediarioNombre(cliente.agencia)}</div>
                              {agenciaContacts.length > 0 ? (
                                agenciaContacts.map((user, idx) => (
                                  <div key={user.id || idx} style={{ marginBottom: "2px", paddingLeft: "10px" }}>
                                    {`${user.nombre} ${user.apellido}`}
                                  </div>
                                ))
                              ) : (
                                <div style={{ paddingLeft: "10px", color: "#666", fontStyle: "italic" }}>
                                  Sin contactos de agencia
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="fw-bold text-success">Trato directo</div>
                          )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editUltimoContacto}>
                                  <DatePicker
                                    selected={ultimo_contacto_fecha_agencia}
                                    onChange={(date) => setUltimoContactoFechaAgencia(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    maxDate={new Date()}
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6;
                                    }}
                                  />
                                </div>
                              ) : cliente.ultimo_contacto_fecha_agencia ? (
                                getDaysDifference(cliente.ultimo_contacto_fecha_agencia, false)
                              ) : (
                                "-"
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editUltimoContacto}>
                                  <select
                                    value={ultimo_contacto_accion_agencia}
                                    className={styles.smallInput}
                                    onChange={(e) => setUltimoContactoAccionAgencia(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                </div>
                              ) : (
                                toUpperCase(cliente.ultimo_contacto_accion_agencia || "-")
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editProximoContacto}>
                                  <DatePicker
                                    selected={proximo_contacto_fecha_agencia}
                                    onChange={(date) => setProximoContactoFechaAgencia(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    minDate={new Date()}
                                    maxDate={() => {
                                      const maxDate = new Date();
                                      maxDate.setMonth(maxDate.getMonth() + 3);
                                      return maxDate;
                                    }}
                                    startDate={new Date()}
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6;
                                    }}
                                    monthsShown={3}
                                  />
                                </div>
                              ) : cliente.proximo_contacto_fecha_agencia ? (
                                (() => {
                                  const text = getDaysDifference(cliente.proximo_contacto_fecha_agencia, true);
                                  const status = getStatusFromText(text, true);
                                  return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                })()
                              ) : (
                                "-"
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editProximoContacto}>
                                  <select
                                    value={proximo_contacto_accion_agencia}
                                    className={styles.smallInput}
                                    onChange={(e) => setProximoContactoAccionAgencia(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                </div>
                              ) : (
                                toUpperCase(cliente.proximo_contacto_accion_agencia || "-")
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" &&
                            (String(id) === String(cliente.ejecutivo) ||
                              cliente.ejecutivos_asignados?.includes(Number(id)))) ||
                          rol === "comercial" ? (
                                !editingAgenciaContact ? (
                                  <FaEdit
                                    onClick={() => {
                                      console.log(
                                        "Intentando editar agencia - cliente.ejecutivo:",
                                        cliente.ejecutivo,
                                        "ejecutivos_asignados:",
                                        cliente.ejecutivos_asignados
                                      );
                                      setEditingClienteId(cliente.id);
                                      setEditingAgenciaContact(cliente.id);
                                      setUltimoContactoFechaAgencia(
                                        cliente.ultimo_contacto_fecha_agencia
                                          ? parseLocalDate(cliente.ultimo_contacto_fecha_agencia)
                                          : null
                                      );
                                      setUltimoContactoAccionAgencia(cliente.ultimo_contacto_accion_agencia || "");
                                      setProximoContactoFechaAgencia(
                                        cliente.proximo_contacto_fecha_agencia
                                          ? parseLocalDate(cliente.proximo_contacto_fecha_agencia)
                                          : null
                                      );
                                      setProximoContactoAccionAgencia(cliente.proximo_contacto_accion_agencia || "");
                                    }}
                                  />
                                ) : editingAgenciaContact === cliente.id ? (
                                  <FiSave
                                    onClick={() =>
                                      handleUpdateCliente(
                                        cliente.id,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        ultimo_contacto_fecha_agencia,
                                        ultimo_contacto_accion_agencia,
                                        proximo_contacto_fecha_agencia,
                                        proximo_contacto_accion_agencia,
                                        cliente.contacto_cliente,
                                        cliente.contacto_agencia,
                                        tipoCliente
                                      )
                                        .then(() => {
                                          setEditingAgenciaContact(null);
                                          toast.success("Datos guardados exitosamente");
                                        })
                                        .catch((error) => {
                                          console.error("Error al guardar:", error);
                                          toast.error("Error al guardar los datos");
                                        })
                                    }
                                  />
                                ) : (
                                  "-"
                                )
                              ) : (
                                "-"
                              )}
                        </td>
                        <td
                          className="text-center"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}
                        >
                          {toUpperCase(cliente.categoria_cliente || "-")}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasYTD[cliente.id] !== undefined &&
  ventasData.ventasYTD[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasYTD[cliente.id], ventasMoneda === "US$")
                            : "-"}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasHTD[cliente.id] !== undefined &&
  ventasData.ventasHTD[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasHTD[cliente.id], ventasMoneda === "US$")
                            : "-"}
                        </td>
                      </tr>
                      <tr
                        className={isOdd ? styles.oddPair : styles.evenPair}
                        data-pair-index={index}
                        data-bg={isOdd ? "odd" : "even"}
                      >
                        <td
                          className="text-start"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "top" }}
                        >
                          <div className="fw-bold">Cliente</div>
                          {clienteContacts.length > 0 ? (
                            clienteContacts.map((user, idx) => (
                              <div key={user.id || idx} style={{ marginBottom: "2px", paddingLeft: "10px" }}>
                                {`${user.nombre} ${user.apellido}`}
                              </div>
                            ))
                          ) : (
                            <div style={{ paddingLeft: "10px", color: "#666", fontStyle: "italic" }}>
                              Sin contactos del cliente
                            </div>
                          )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  getDaysDifference(cliente.ultimo_contacto_fecha_cliente, false)
                                ) : editingClienteContact === cliente.id ? (
                                  <DatePicker
                                    selected={ultimo_contacto_fecha_cliente}
                                    onChange={(date) => setUltimoContactoFechaCliente(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    maxDate={new Date()} // Solo permite fechas pasadas para último contacto
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6; // Excluir domingos y sábados
                                    }}
                                  />
                                ) : (
                                  getDaysDifference(cliente.ultimo_contacto_fecha_cliente, false)
                                )
                              ) : (
                                getDaysDifference(cliente.ultimo_contacto_fecha_cliente, false) || "-"
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  toUpperCase(cliente.ultimo_contacto_accion_cliente || "-")
                                ) : editingClienteContact === cliente.id ? (
                                  <select
                                    value={ultimo_contacto_accion_cliente}
                                    className={styles.smallInput}
                                    onChange={(e) => setUltimoContactoAccionCliente(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                ) : (
                                  toUpperCase(cliente.ultimo_contacto_accion_cliente || "-")
                                )
                              ) : (
                                toUpperCase(cliente.ultimo_contacto_accion_cliente || "-")
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  cliente.proximo_contacto_fecha_cliente ? (
                                    (() => {
                                      const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                      const status = getStatusFromText(text, true);
                                      return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                    })()
                                  ) : (
                                    "-"
                                  )
                                ) : editingClienteContact === cliente.id ? (
                                  <DatePicker
                                    selected={proximo_contacto_fecha_cliente}
                                    onChange={(date) => setProximoContactoFechaCliente(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    minDate={new Date()}
                                    maxDate={() => {
                                      const maxDate = new Date();
                                      maxDate.setMonth(maxDate.getMonth() + 3);
                                      return maxDate;
                                    }}
                                    startDate={new Date()}
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6;
                                    }}
                                    monthsShown={3}
                                  />
                                ) : cliente.proximo_contacto_fecha_cliente ? (
                                  (() => {
                                    const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                    const status = getStatusFromText(text, true);
                                    return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                  })()
                                ) : (
                                  "-"
                                )
                              ) : cliente.proximo_contacto_fecha_cliente ? (
                                (() => {
                                  const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                  const status = getStatusFromText(text, true);
                                  return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                })()
                              ) : (
                                "-"
                              )}
                        </td>
                        <td style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                                ) : editingClienteContact === cliente.id ? (
                                  <select
                                    value={proximo_contacto_accion_cliente}
                                    className={styles.smallInput}
                                    onChange={(e) => setProximoContactoAccionCliente(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                ) : (
                                  toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                                )
                              ) : (
                                toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" &&
                            (String(id) === String(cliente.ejecutivo) ||
                              cliente.ejecutivos_asignados?.includes(Number(id)))) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  <FaEdit
                                    onClick={() => {
                                      console.log(
                                        "Intentando editar cliente - cliente.ejecutivo:",
                                        cliente.ejecutivo,
                                        "ejecutivos_asignados:",
                                        cliente.ejecutivos_asignados
                                      );
                                      setEditingClienteId(cliente.id);
                                      setEditingClienteContact(cliente.id);
                                      setUltimoContactoFechaCliente(
                                        cliente.ultimo_contacto_fecha_cliente
                                          ? parseLocalDate(cliente.ultimo_contacto_fecha_cliente)
                                          : null
                                      );
                                      setUltimoContactoAccionCliente(cliente.ultimo_contacto_accion_cliente || "");
                                      setProximoContactoFechaCliente(
                                        cliente.proximo_contacto_fecha_cliente
                                          ? parseLocalDate(cliente.proximo_contacto_fecha_cliente)
                                          : null
                                      );
                                      setProximoContactoAccionCliente(cliente.proximo_contacto_accion_cliente || "");
                                    }}
                                  />
                                ) : editingClienteContact === cliente.id ? (
                                  <FiSave
                                    onClick={() =>
                                      handleUpdateCliente(
                                        cliente.id,
                                        cliente.ejecutivo,
                                        cliente.agencia,
                                        ultimo_contacto_fecha_cliente,
                                        ultimo_contacto_accion_cliente,
                                        proximo_contacto_fecha_cliente,
                                        proximo_contacto_accion_cliente,
                                        null,
                                        null,
                                        null,
                                        null,
                                        cliente.contacto_cliente,
                                        cliente.contacto_agencia,
                                        tipoCliente
                                      )
                                        .then(() => {
                                          setEditingClienteContact(null);
                                          toast.success("Datos guardados exitosamente");
                                        })
                                        .catch((error) => {
                                          console.error("Error al guardar:", error);
                                          toast.error("Error al guardar los datos");
                                        })
                                    }
                                  />
                                ) : (
                                  "-"
                                )
                              ) : (
                                "-"
                              )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            )}
          </table>
          {isModalOpen && (
            <div
              className="modal"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "5px",
                  minWidth: "200px",
                  textAlign: "center",
                }}
              >
                <h5>Cambiar estatus de oportunidad</h5>
                <div style={{ marginTop: "15px" }}>
                  {selectedOportunidadId && (
                    <div>
                      {todasLasOportunidades.find((op) => op.id === selectedOportunidadId && op.estatus === "90%") && (
                        <>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("100%"),
                              color: getLabelColorForStatus("100%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "100%");
                              setIsModalOpen(false);
                            }}
                          >
                            100%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("75%"),
                              color: getLabelColorForStatus("75%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "75%");
                              setIsModalOpen(false);
                            }}
                          >
                            75%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("50%"),
                              color: getLabelColorForStatus("50%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "50%");
                              setIsModalOpen(false);
                            }}
                          >
                            50%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("0%"),
                              color: getLabelColorForStatus("0%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "0%");
                              setIsModalOpen(false);
                            }}
                          >
                            0%
                          </button>
                        </>
                      )}
                      {todasLasOportunidades.find((op) => op.id === selectedOportunidadId && op.estatus === "75%") && (
                        <>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("100%"),
                              color: getLabelColorForStatus("100%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "100%");
                              setIsModalOpen(false);
                            }}
                          >
                            100%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("90%"),
                              color: getLabelColorForStatus("90%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "90%");
                              setIsModalOpen(false);
                            }}
                          >
                            90%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("50%"),
                              color: getLabelColorForStatus("50%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "50%");
                              setIsModalOpen(false);
                            }}
                          >
                            50%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("0%"),
                              color: getLabelColorForStatus("0%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "0%");
                              setIsModalOpen(false);
                            }}
                          >
                            0%
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
                <button
                  style={{
                    marginTop: "15px",
                    padding: "5px 10px",
                    backgroundColor: "grey",
                    color: "white",
                    border: "none",
                    borderRadius: "3px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}
          <Modal isOpen={isFlashEditing} toggle={() => setIsFlashEditing(false)} size="lg">
            <ModalHeader>Edición FLASH #{flashEditingOpportunity?.id || "Cargando..."}</ModalHeader>
            <ModalBody>
              {flashEditingOpportunity ? (
                <FormProvider {...methods}>
                  <form onSubmit={handleSubmit(onSubmitFlashEdit)}>
                    <div className="row g-3">
                      <div className="col-4">
                        <label htmlFor="flash_estatus" className="form-label">
                          Estatus
                        </label>
                        <select
                          className={`form-control ${errors.estatus ? "is-invalid" : ""}`}
                          id="flash_estatus"
                          {...register("estatus", { required: "Este campo es obligatorio" })}
                        >
                          <option value="">Selecciona un porcentaje</option>
                          <option value="100%">100%</option>
                          <option value="90%">90%</option>
                          <option value="75%">75%</option>
                          <option value="50%">50%</option>
                          <option value="0%">0%</option>
                        </select>
                        {errors.estatus && <div className="invalid-feedback">{errors.estatus.message}</div>}
                      </div>
                      <div className="col-4">
                        <label htmlFor="flash_mes_cierre" className="form-label">
                          Mes de Cierre
                        </label>
                        <select
                          className={`form-control ${errors.mes_cierre ? "is-invalid" : ""}`}
                          id="flash_mes_cierre"
                          {...register("mes_cierre", { required: "Este campo es obligatorio" })}
                        >
                          {months.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>
                        {errors.mes_cierre && <div className="invalid-feedback">{errors.mes_cierre.message}</div>}
                      </div>
                      <div className="col-4">
                        <label htmlFor="flash_ano_cierre" className="form-label">
                          Año de Cierre
                        </label>
                        <select
                          className={`form-control ${errors.ano_cierre ? "is-invalid" : ""}`}
                          id="flash_ano_cierre"
                          {...register("ano_cierre", { required: "Este campo es obligatorio" })}
                        >
                          <option value={CURRENT_YEAR}>{CURRENT_YEAR}</option>
                          <option value={(parseInt(CURRENT_YEAR) + 1).toString()}>{parseInt(CURRENT_YEAR) + 1}</option>
                          <option value={(parseInt(CURRENT_YEAR) + 2).toString()}>{parseInt(CURRENT_YEAR) + 2}</option>
                        </select>
                        {errors.ano_cierre && <div className="invalid-feedback">{errors.ano_cierre.message}</div>}
                      </div>
                      <div className="col-4">
                        <label htmlFor="flash_mes_factura" className="form-label">
                          Mes Facturación
                        </label>
                        <select
                          className={`form-control ${errors.mes_factura ? "is-invalid" : ""}`}
                          id="flash_mes_factura"
                          {...register("mes_factura", { required: "Este campo es obligatorio" })}
                        >
                          {months.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>
                        {errors.mes_factura && <div className="invalid-feedback">{errors.mes_factura.message}</div>}
                      </div>
                      <div className="col-4">
                        <label htmlFor="flash_ano_factura" className="form-label">
                          Año Facturación
                        </label>
                        <select
                          className={`form-control ${errors.ano_factura ? "is-invalid" : ""}`}
                          id="flash_ano_factura"
                          {...register("ano_factura", { required: "Este campo es obligatorio" })}
                        >
                          <option value="2025">2025</option>
                          <option value="2026">2026</option>
                          <option value="2027">2027</option>
                        </select>
                        {errors.ano_factura && <div className="invalid-feedback">{errors.ano_factura.message}</div>}
                      </div>
                    </div>
                  </form>
                </FormProvider>
              ) : (
                <p>Cargando...</p>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setIsFlashEditing(false)} disabled={loading}>
                Cancelar
              </Button>
              <Button color="primary" onClick={handleSubmit(onSubmitFlashEdit)} disabled={loading}>
                {loading ? "Guardando..." : "Guardar"}
              </Button>
            </ModalFooter>
          </Modal>
        </>
      )}
    </div>
  );
};
